














export default {
    name: 'BaseInputField',
    components: {},
    props: {
        label: String,
        inputName: String,
        type: String,
        placeholder: String,
        field: String,
    },
    data() {
        return {};
    },
    methods: {
        onEnter() {
            this.$emit('enter');
        },
        onChange(event) {
            this.$emit('update:field', event.target.value);
        },
    },
};
